import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://balkandestination.com';

/**
 * DefaultCanonical
 *
 * Injects a <link rel="canonical"> tag into every public page based on the
 * current pathname. Page-level Helmet declarations declared LATER (e.g.
 * inside <SEOHead>) take precedence — Helmet uses last-wins semantics for
 * link[rel=canonical], so individual pages can still override this default
 * without conflict.
 *
 * This solves the "subpages indexed under www. variant with no declared
 * canonical" warning surfaced by Google Search Console.
 */
const DefaultCanonical = () => {
  const { pathname } = useLocation();

  // Skip admin / partner / authenticated routes — they should not be in
  // Google's index anyway, and we don't want to advertise a canonical URL
  // for back-office pages.
  if (
    pathname.startsWith('/admin') ||
    pathname.startsWith('/partner-') ||
    pathname.startsWith('/guide-portal') ||
    pathname.startsWith('/site-portal') ||
    pathname.startsWith('/client/') ||
    pathname.startsWith('/agent/') ||
    pathname.startsWith('/login') ||
    pathname.startsWith('/register')
  ) {
    return null;
  }

  // Strip query string + trailing slash (except root) for clean canonicals.
  let path = pathname || '/';
  if (path.length > 1 && path.endsWith('/')) path = path.slice(0, -1);
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <link rel="canonical" href={url} />
      <meta property="og:url" content={url} />
    </Helmet>
  );
};

export default DefaultCanonical;
